<script>

export default {
    methods: {
        displayImg (item) {
            if (item.media) {
                let media = item.media;

                if (Array.isArray(item.media)) {
                    media = item.media[0]
                } 

                if (media.mime_type == 'image') {
                    return media.url
                }
            }
            return false;
        },
        displayMedia (item) {
             if (item.media) {
                let media = item.media;

                if (Array.isArray(item.media)) {
                    media = item.media[0]
                } 

                if (media.mime_type != 'image') {
                    return media.url.split('.').pop();
                }
            }

            return false;
        }
    }
}
</script>